export const JURIS_INFO = 'JURIS_INFO';
export const VARIABLE_LIST = 'VARIABLE_LIST';
export const SUBGROUPS_LIST = 'SUBGROUPS_LIST';
export const STAT_LIST = 'STAT_LIST';
export const EXCEL_OPTION = 'EXCEL_OPTION';

export const PDCHART = 'CHART';
export const PDTABLE = 'TABLE';

export const SE_ON = 'ON';
export const SE_OFF = 'OFF';